import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import {
  formatDateTimeStamp,
  getFormattedTime,
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../../../global.variable';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { ClientsService } from '../../../clients/clients.service';
import { JobsService } from '../../../jobs/jobs.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { AddScheduledReportsComponent } from '../../../../../shared/components/add-scheduled-reports/add-scheduled-reports.component';
import { ClientSiteContactsComponent } from '../../../../../shared/components/client-site-contacts/client-site-contacts.component';
import { EventSchedulerComponent } from '../../../../../shared/components/event-scheduler/event-scheduler.component';

@Component({
  selector: 'gtapp-scheduled-reports',
  standalone: false,
  templateUrl: './scheduled-reports.component.html',
  styleUrl: './scheduled-reports.component.scss',
})
export class ScheduledReportsComponent implements OnInit, OnDestroy {
  largeView: Boolean = isLargeScreen;

  contactForm: UntypedFormGroup = new UntypedFormGroup({
    first_name: new UntypedFormControl('', [Validators.required]),
    last_name: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    mobile_number: new UntypedFormControl(null, [
      Validators.minLength(7),
      Validators.maxLength(10),
      Validators.pattern('^[0-9]*$'),
    ]),
  });

  newReportData: any = {
    site_data: [{}],
    company_data: [{}],
    contacts: [],
    mail_time: '10:00',
  };

  initialDataList: any = {};
  siteListData: any = [];
  contactListData: any = [];
  clientDropDownList: any = [];
  contactLookupList: any = [];

  reportStep: number = 1;

  addSites: boolean = true;

  previousScheduledReports: number = 0;
  rowsScheduledReports: number = 5;
  pageNumScheduledReports: number = 1;
  totalPagesScheduledReports: number = 0;
  totalRowsScheduledReports: number = 0;
  // scheduledReportsDataList: any = [];
  scheduledReportsPaginationData: any = {};
  otherParamsScheduledReport: any = {
    apiFiltering: true,
  };
  tableStyle = {
    'overflow': 'auto',
    'max-height': 'calc(100vh - 235px)',
  };
  selectedScheduledReportData: any = {};
  sortKeyScheduledReport: any;
  searchParamsScheduledReport: any;

  scheduledReportsColumns: any = [];

  jobTypesDataListNames: any = [];

  passedIdInRoute: string = '';

  selectedClient: any = {};
  selectedSite: any = {};

  constructor(
    private spinnerService: LoadingSpinnerService,
    private jobService: JobsService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private clientService: ClientsService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.getTableDetails();
    this.searchClients('');
    this.getJobTypes();

    const routeParams: any = this.route.snapshot.queryParams;
    if (routeParams && routeParams?.sKey) {
      // called from job-review page
      this.passedIdInRoute = atob(routeParams?.sKey);
      this.getScheduledReports();
    }

    let siteInfo = this.route.snapshot.queryParams?.['siteInfo'];
    let clientInfo = this.route.snapshot.queryParams?.['clientInfo'];

    if (clientInfo) {
      clientInfo = JSON.parse(atob(clientInfo));
      if (clientInfo?.id) {
        this.onClientSelect(clientInfo);
      }
    } else if (siteInfo) {
      siteInfo = JSON.parse(atob(siteInfo));

      if (siteInfo?.id) {
        this.selectedClient = siteInfo?.company;
        this.onSiteSearch('');
        this.onSelectSite(siteInfo);
      }
    }

    if (this.passedIdInRoute && this.largeView) {
      this.getScheduledReportDetail({
        item_id: this.passedIdInRoute,
        report_type_descriptor: 2,
      });
    }
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true, // Replaces the current URL without adding a new history entry
    });
  }
  getScheduledReportsCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.clientService
      .listScheduledPatrolReprots(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsScheduledReport = {
            ...this.otherParamsScheduledReport,
            paginationData: {
              totalRows: response?.total_count,
              previousRows: this.previousScheduledReports,
              rows: this.rowsScheduledReports,
              pageNum: this.pageNumScheduledReports,
              totalPages: this.totalPagesScheduledReports,
              fixedRows: true,
            },
          };
        }
      });
  }
  getScheduledReports(getCount = true, initialCall = false) {
    let params: any = {};

    let searchParams: any = { ...(this.searchParamsScheduledReport || {}) };
    if (this.selectedClient?.id) {
      searchParams = {
        ...(searchParams || {}),
        company_name__icontains: this.selectedClient?.company_name,
        company_uuid: this.selectedClient?.id,
      };
    }
    if (this.selectedSite?.id) {
      searchParams = {
        ...(searchParams || {}),
        site_name__icontains: this.selectedSite?.company_name,
        site_uuid: this.selectedSite?.id,
      };
    }

    if (this.rowsScheduledReports) {
      params['rows'] = this.rowsScheduledReports;
    }
    if (this.previousScheduledReports) {
      params['previous'] = this.previousScheduledReports;
    }
    if (this.sortKeyScheduledReport) {
      params['order_by'] = this.sortKeyScheduledReport;
    }
    if (searchParams && Object.keys(searchParams)?.length) {
      params['search_params'] = JSON.stringify(searchParams);
    }
    if (this.passedIdInRoute) params['report_id'] = btoa(this.passedIdInRoute);

    if (
      this.scheduledReportsPaginationData?.[this.pageNumScheduledReports]
        ?.length
    )
      return;
    this.spinnerService.show();
    if (getCount) this.getScheduledReportsCount(params);
    this.selectedScheduledReportData = {};

    this.clientService
      .listScheduledPatrolReprots(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.scheduledReportsPaginationData[this.pageNumScheduledReports] = [
            ...response?.data,
          ];

          // if (!response?.data?.length && initialCall) {
          //   this.addNewSchedule();
          // }

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationScheduledReport(data: any) {
    this.previousScheduledReports = data?.paginationData?.previousRows;
    this.pageNumScheduledReports = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsScheduledReports) {
      this.scheduledReportsPaginationData = {};
    }
    this.rowsScheduledReports = data?.paginationData?.rows;

    this.otherParamsScheduledReport.paginationData = {
      ...data?.paginationData,
      fixedRows: true,
    };
    this.getScheduledReports(false);
  }
  sortColumnScheduledReport(body: any) {
    this.sortKeyScheduledReport = body?.sortList || [];
    this.searchParamsScheduledReport = body?.searchParams || {};
    this.scheduledReportsPaginationData = {};
    if (body?.site_id) {
      this.searchParamsScheduledReport = {
        ...this.searchParamsScheduledReport,
        site_uuid: body?.site_id,
      };
    }
    this.getScheduledReports(false);
  }
  searchColumnScheduledReport(event: any) {
    this.searchParamsScheduledReport = event?.searchParams || {};
    this.pageNumScheduledReports = 1;
    this.previousScheduledReports = 0;
    this.scheduledReportsPaginationData = {};
    if (event?.site_id) {
      this.searchParamsScheduledReport = {
        ...this.searchParamsScheduledReport,
        site_uuid: event?.site_id,
      };
    }
    this.getScheduledReports();
  }
  async onItemSelect(selectedData: any, template?: any) {
    // report_type_descriptor
    // 1: one time jobs
    // 2: scheduled job reports
    // 3: cp scheduled reports
    // 4: job report contacts
    this.selectedScheduledReportData = {};
    // this.getScheduledReportDetail(selectedData, template);

    if (selectedData?.report_type_descriptor === 2) {
      this.getScheduledReportDetail(selectedData, template);
    } else if (selectedData?.report_type_descriptor === 4) {
      let params: any = {
        company_id: selectedData?.company_uuid,
        report_type_descriptor: selectedData?.report_type_descriptor,
      };
      if (selectedData?.site_uuid) params.site_id = selectedData?.site_uuid;
      this.spinnerService.show();
      const response: any = await this.getItemDetails(
        selectedData?.item_id,
        params,
      );
      this.openJobReportContactTemplate(
        selectedData,
        response?.data?.contacts || [],
      );
      this.spinnerService.hide();
    } else if (selectedData?.report_type_descriptor === 3) {
      let params: any = {
        report_id: selectedData?.item_id,
        report_type_descriptor: selectedData?.report_type_descriptor,
      };
      this.spinnerService.show();
      const response: any = await this.getItemDetails(
        selectedData?.item_id,
        params,
      );

      this.openCpScheduledReport(selectedData, response?.data || {});
      this.spinnerService.hide();
      // if (selectedData?.site_uuid) {
      //   this.router.navigate([
      //     '/view-site',
      //     { sKey: String(selectedData?.site_uuid) },
      //   ]);
      // } else {
      //   this.router.navigate([
      //     '/view-client',
      //     { cKey: String(selectedData?.company_uuid) },
      //   ]);
      // }
    } else {
      this.router.navigate([`/job-review/${selectedData?.name}`], {
        queryParams: { jId: selectedData?.id },
      });
    }
  }

  openCpScheduledReport(selectedData: any, schedule: any) {
    let data: any = { scheduleData: schedule };

    if (selectedData?.site_uuid) {
      data['siteData'] = {
        id: selectedData?.site_uuid,
        company_name: selectedData?.site_name,
        company: {
          id: selectedData?.company_uuid,
          company_name: selectedData?.company_name,
        },
      };
    } else {
      data['clientData'] = {
        id: selectedData?.company_uuid,
        company_name: selectedData?.company_name,
      };
    }

    const dialogRef = this.dialogService.open(EventSchedulerComponent, {
      data: data,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) this.resetFilter();
    });
  }
  openJobReportContactTemplate(selectedData: any, contacts: any) {
    let data: any = {
      contactType: 'jc',
      selectedUsers: contacts,
    };

    if (selectedData?.site_uuid) {
      data['siteData'] = {
        id: selectedData?.site_uuid,
        company_name: selectedData?.site_name,
        company: {
          id: selectedData?.company_uuid,
          company_name: selectedData?.company_name,
        },
      };
    } else {
      data['clientData'] = {
        id: selectedData?.company_uuid,
        company_name: selectedData?.company_name,
      };
    }

    this.dialogService.open(ClientSiteContactsComponent, {
      data: data,
    });
  }
  getItemDetails = async (id: any, params: any) => {
    return new Promise((resolve) => {
      this.clientService
        .getScheduledPatrolReprotById(btoa(id), params)
        .subscribe((response: any) => resolve(response));
    });
  };
  async getScheduledReportDetail(selectedData: any, template?: any) {
    if (this.selectedScheduledReportData?.item_id === selectedData?.item_id)
      return;
    this.selectedScheduledReportData = selectedData;
    let params: any = {
      report_type_descriptor: selectedData?.report_type_descriptor,
    };

    this.spinnerService.show();
    const response: any = await this.getItemDetails(
      selectedData?.item_id,
      params,
    );

    if (response?.status == 'success') {
      this.selectedScheduledReportData = {
        ...this.selectedScheduledReportData,
        ...response?.data,
      };
      if (template)
        this.dialogService.open(
          template,
          { data: selectedData },
          this.viewContainerRef,
        );
      this.spinnerService.hide();
    } else {
      this.spinnerService.hide();
    }
  }

  mobileNumberCheck() {
    if (!this.contactForm.value?.mobile_number) {
      this.contactForm.controls['mobile_number'].setValue(null);
      this.contactForm.controls['mobile_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.contactForm.controls['mobile_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  dupContactCheck() {
    const dupContactExists = this.newReportData?.contacts?.some(
      (contact: any) => contact?.email === this.contactForm.value?.email,
    );
    return dupContactExists;
  }

  roundDateTimeToQuarterHour = (event: any) => {
    const newDate = new Date();
    const [hours, minutes] = event.target.value?.split(':') || ['0', '0'];
    newDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    const msPerQuarter = 15 * 60 * 1000;
    const rounded = Math.round(newDate.getTime() / msPerQuarter) * msPerQuarter;
    setTimeout(() => {
      this.newReportData.mail_time = getFormattedTime(rounded);
    }, 500);
  };
  addNewSchedule() {
    const dialogRef = this.dialogService.open(AddScheduledReportsComponent, {});
    dialogRef?.afterClosed().subscribe((res: any) => {
      if (res) {
        this.resetFilter();
      }
    });
  }
  openTemplate(template: any, body?: any) {
    body = body || {};
    body.backupData = JSON.parse(JSON.stringify(body || {}));
    if (body?.source === 'contacts') {
      this.newReportData.contacts = JSON.parse(
        JSON.stringify(
          this.selectedScheduledReportData?.contacts ||
            this.newReportData?.contacts ||
            [],
        ),
      );
      this.contactForm.reset();
    }
    if (body?.source === 'mail_time') {
      this.newReportData.mail_time =
        this.selectedScheduledReportData?.report_time;
    }
    if (body?.source === 'name') {
      this.newReportData.name = this.selectedScheduledReportData?.name;
    }
    if (body?.source === 'new_schedule') {
      this.selectedScheduledReportData = {};
      this.newReportData = {
        site_data: [{}],
        company_data: [{}],
        contacts: [],
        mail_time: '10:00',
      };

      this.reportStep = 1;
    }

    const dialogRef = this.dialogService.open(
      template,
      { data: body },
      this.viewContainerRef,
    );
    dialogRef?.afterClosed().subscribe((res: any) => {
      if (body?.source === 'contacts') {
        if (res?.email) {
          const dupContactExists = this.newReportData?.contacts?.some(
            (contact: any) => contact?.email === res?.email,
          );
          if (dupContactExists) {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: 'Email already added!!!',
            });
            return;
          }
          if (body?.id) {
            this.updateReport('add_contact', { contact: res });
          } else {
            this.contactForm.reset();
            this.newReportData?.contacts.push(res);
          }
        }
      }
    });
  }
  updateReportTableList() {
    const index1 = this.scheduledReportsPaginationData?.[
      this.pageNumScheduledReports
    ]?.findIndex(
      (item: any) => item?.item_id == this.selectedScheduledReportData?.id,
    );

    if (index1 > -1) {
      this.scheduledReportsPaginationData[this.pageNumScheduledReports][
        index1
      ] = {
        ...this.scheduledReportsPaginationData?.[this.pageNumScheduledReports][
          index1
        ],
        ...this.selectedScheduledReportData,
      };

      this.otherParamsScheduledReport = {
        ...this.otherParamsScheduledReport,
      };
    }
  }
  updateReport(source: string, body?: any, params?: any) {
    params = params || {};
    body = body || {};
    this.spinnerService.show();
    switch (source) {
      case 'mail_time':
        params.update_mail_time = 1;
        body.mail_time = this.newReportData?.mail_time;
        break;
      case 'name':
        params.update_name = 1;
        body.name = this.newReportData?.name;
        break;
      case 'add_contact':
        params.add_contact = 1;
        break;
      case 'remove_contact':
        params.remove_contact = 1;
        break;
      case 'remove_job_from_queue':
        params.remove_job_from_queue = 1;
        break;
      case 'readd_job_to_queue':
        params.readd_job_to_queue = 1;
        break;
      case 'delete_report':
        params.delete_report = 1;
        break;
    }

    this.clientService
      .updateScheduledPatrolReprotById(
        btoa(this.selectedScheduledReportData?.id),
        body,
        params,
      )
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          switch (source) {
            case 'mail_time':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };
              this.updateReportTableList();

              break;
            case 'name':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };

              this.updateReportTableList();
              break;
            case 'add_contact':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };

              break;
            case 'remove_contact':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };

              break;
            case 'remove_job_from_queue':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };
              break;
            case 'readd_job_to_queue':
              this.selectedScheduledReportData = {
                ...this.selectedScheduledReportData,
                ...response?.data,
              };
              break;
            case 'delete_report':
              this.resetFilter();

              break;
          }
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  deleteContact(contactId: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: `Delete recipient`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateReport('remove_contact', { contact_id: contactId });
      }
    });
  }
  redirectToJob(jobData: any) {
    this.router.navigate([`/job-review/${jobData?.job_key}`], {
      queryParams: { jId: jobData?.id },
    });
  }
  addRemoveJob(jobData: any, remove = false) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: '',
        message: remove
          ? `Remove report from queue?`
          : `Add report to schedule?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateReport(
          remove ? 'remove_job_from_queue' : 'readd_job_to_queue',
          { job_id: jobData?.id },
        );
      }
    });
  }
  deleteSchedule() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'Delete schedule',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateReport('delete_report', {});
      }
    });
  }
  onContactSearch(event: any) {
    if (event?.target?.value?.length > 2) {
      let params: any = { list_contacts: 1, search_str: event?.target?.value };
      const alreadySelectedEmails = [
        ...new Set(
          this.newReportData?.contacts?.map((item: any) => item?.email),
        ),
      ];
      if (alreadySelectedEmails?.length)
        params.exclude_emails = JSON.stringify(alreadySelectedEmails);
      this.clientService
        .listScheduledPatrolReprots(params)
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.contactListData = response?.data;
          }
        });
    }
  }
  filterJobs() {
    const searchStr = this.selectedScheduledReportData.searchStr;

    this.selectedScheduledReportData.filteredJobList =
      this.selectedScheduledReportData?.jobs?.filter((item: any) =>
        item?.job_key?.toLowerCase().includes(searchStr?.toLowerCase()),
      );
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  getJobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.jobTypesDataListNames = response?.data
          ?.filter((jType: any) =>
            [0, 1, 2, 5, 6].includes(jType?.type_identity),
          )
          ?.map((item: any) => item?.name);
      }
    });
  }

  resetFilter(cleaAll = false) {
    if (cleaAll) {
      this.selectedClient = {};
      this.selectedSite = {};
    }

    this.passedIdInRoute = '';
    this.scheduledReportsPaginationData = {};
    this.getScheduledReports();
  }
  getTableDetails() {
    const searchParams = { ...(this.searchParamsScheduledReport || {}) };
    let tableDetails = this.largeView
      ? [
          {
            header: 'Time',
            nestedValue: (row: any) => {
              return row?.report_type_descriptor == 4
                ? row?.report_time
                  ? 'On Completion'
                  : 'Manual'
                : row?.report_type_descriptor == 1
                  ? formatDateTimeStamp(
                      row?.report_time,
                      'd MMM y HH:mm',
                      'en_US',
                    )
                  : row?.report_time;
            },
            sortKey: 'report_time',
            suffixStyle: {
              'white-space': 'pre-line',
              'font-size': 'small',
              'color': 'var(--bs-secondary)',
            },
            suffixNestedValue: (row: any) => {
              return row?.repeat_type ? `\n[${row?.repeat_type}]` : null;
            },
          },

          {
            header: 'Site/Client',
            sortKey: this.selectedSite?.id ? '' : 'site_name',
            name: 'site_name',
            // searchKey: 'site_name',
            // autoComplete: 'site',
            columnDataStyle: {
              'white-space': 'pre-line',
            },
            nestedValue: (row: any) => {
              return row?.site_name || row?.company_name;
            },

            conditionalSuffixStyle: (row: any) => {
              if (row?.site_address)
                return {
                  'white-space': 'pre-line',
                  'font-size': 'small',
                  'color': 'var(--bs-secondary)',
                };
              return {
                'border': '1px solid',
                'border-radius': '5px',
                'padding': '0 0.5rem',
                'font-size': 'small',
                'text-align': 'center',
                'white-space': 'pre-line',
              };
            },
            suffixNestedValue: (row: any) => {
              if (row?.site_address) return `\n ${row?.site_address}`;
              return 'All Sites';
            },
          },

          {
            header: 'Job Type(s)',
            nestedValue: (row: any) => {
              if (!row?.job_type_list?.length)
                return this.jobTypesDataListNames?.join(', ');
              return row?.job_type_list?.join(', ');
            },
          },
        ]
      : [
          {
            tableColumnStyle: {
              'color': 'var(--text-secondary)',
              'white-space': 'pre-line',
              'vertical-align': 'top',
            },
            nestedValue: (row: any) => {
              return row?.site_name || row?.company_name;
            },
            columnDataStyle: {
              'font-size': '16px',
            },
            searchKey: 'site_name',
            sortKey: 'site_name',
            prefixNestedValue: (row: any) => {
              const mailTime =
                row?.report_type_descriptor == 4
                  ? row?.report_time
                    ? 'On Completion'
                    : 'Manual'
                  : row?.report_type_descriptor == 1
                    ? formatDateTimeStamp(
                        row?.report_time,
                        'd MMM y HH:mm',
                        'en_US',
                      )
                    : row?.report_time;
              if (!mailTime) return null;
              return `Mail Time: ${mailTime} ${row?.repeat_type ? `[${row?.repeat_type}]` : ''}\n`;
            },

            conditionalSuffixStyle: (row: any) => {
              if (row?.site_address)
                return {
                  'white-space': 'pre-line',
                  'font-size': 'small',
                  'color': 'var(--bs-secondary)',
                };
              return {
                'border': '1px solid',
                'border-radius': '5px',
                'padding': '0 0.5rem',
                'font-size': 'small',
                'text-align': 'center',
                'white-space': 'pre-line',
              };
            },
            suffixNestedValue: (row: any) => {
              if (row?.site_address) return `\n ${row?.site_address}`;
              return 'All Sites';
            },
            suffix2NestedValue: (row: any) => {
              let suffixValues = [''];

              const jobTypes = row?.job_type_list?.length
                ? row?.job_type_list
                : this.jobTypesDataListNames;

              suffixValues.push('Job Type(s): ' + jobTypes?.join(', '));

              return suffixValues?.join('\n');
            },
          },
        ];

    updateCustomTableHeaders(tableDetails, searchParams);

    this.scheduledReportsColumns = [...tableDetails];
  }
  editField(field: string) {
    if (field == 'site') {
      this.selectedSite = {};
      this.shiftFocus('siteId');
    }
    if (field == 'client') {
      this.selectedClient = {};
      this.selectedSite = {};
      this.shiftFocus('clientLookupId');
    }

    this.updateInitialDataList(field);
  }
  inputFocused(field: string) {
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    this.siteListData = [];
    this.clientDropDownList = [];
    setTimeout(() => {
      if (field === 'site') {
        this.siteListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }

      this.cdr.detectChanges();
    }, 200);
  }

  onClientSearch(event: any) {
    if (event.target.value.length > 2) {
      this.searchClients(event.target.value);
    }
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.initialDataList.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onClientSelect(data: any) {
    this.selectedClient = data;
    this.selectedSite = {};
    this.onSiteSearch('');
    this.resetFilter();
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    let params: any = {
      company: this.selectedClient?.id,
      rows: 15,
      search_str: searchString,
    };

    this.clientService.getSiteList(params).subscribe((response: any) => {
      this.siteListData = response?.data || [];

      if (!event) {
        this.initialDataList.site = JSON.parse(
          JSON.stringify(this.siteListData),
        );
      }
    });
  }
  onSelectSite(data: any) {
    this.selectedSite = data;
    this.resetFilter();
  }
}
